<template>
  <div class="adDeviceReport">
    <commonTable
      ref="commonTable"
      url="/admin/package_statistics/advertiser_package"
      reqMethod="GET"
      :column="column"
      :extraParams="extraParams"
      :searchColumn="searchColumn"
      @reset="() => {
        extraParams = {
          game_id: null,
          channel_id: null,
          game_channel_package_id: null,
        }
        channel_list = []
      }"
      limitKey="per_page"
      summary
    >
      <template slot="search-back">

        <el-form-item label="游戏:">
        <el-select
          v-model="extraParams.game_id"
          clearable
          filterable
          placeholder="请选择"
          @change="clearGame"
          @clear="clearGame">
          <el-option
            v-for="item in gamesList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道:">
        <el-select
          v-model="channel_list"
          filterable
          clearable
          multiple
          collapse-tags
          placeholder="请选择"
          @change="(val) => extraParams.channel_id = val.toString()"
        >
          <el-option
            v-for="item in channelSelectList.filter(i => !extraParams.game_id || i.game_id === extraParams.game_id)"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道包:">
        <el-select
          v-model="extraParams.game_channel_package_id"
          filterable
          clearable
          placeholder="请选择">
          <el-option
            v-for="item in channelPackagesList.filter(i => !extraParams.game_id || i.game_id === extraParams.game_id)"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      </template>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import commonTable from '@/component/commonTable.vue'

export default {
  name: 'adDeviceReport',
  data () {
    return {
      extraParams: {
        game_id: null,
        channel_id: null,
        game_channel_package_id: null,
      },
      gamesList: [],
      channelSelectList: [],
      channelPackagesList: [],
      searchColumn:[{
        label: "日期",
        prop: "created_from+created_to",
        type: "date",
        setDefault: true,
      }],
      channel_list: [],
      column: [
        {
          label: "游戏",
          prop: "game.name",
        },
        {
          label: "游戏母包名",
          prop: "game_package.name",
        },
        {
          label: "渠道包名",
          prop: "packages.name",
        },
        {
          label: "新增设备数",
          prop: "device_num",
          info: "头条30天内去重设备",
        },
        {
          label: "设备7天累计充值",
          prop: "money",
        },
        {
          label: "付费设备数",
          prop: "device_pay_num",
        },
        {
          label: "付费次数",
          prop: "frequency",
        },
      ]
    }
  },
  components: {
    commonTable
  },
  mounted () {
    this.getGameSelectList()
    this.getchannelSelectList()
    this.channelPackagesSelect()
  },
  methods: {
    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data
      })
    },
    clearGame () {
      this.extraParams.channel_id = null
      this.extraParams.game_channel_package_id = null
      this.channel_list = []
    },
    // 获取渠道选择列表数据
    getchannelSelectList() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.channelSelectList = res.data.data
        }
      });
    },
    // 渠道包 下拉选择列表
    channelPackagesSelect() {
      fetch({
        url: "/admin/game_channel_packages/channel_package_select",
        method: "GET",
      }).then((res) => {
        this.channelPackagesList = res.data.data
      })
    },
  }
}
</script>

<style lang="less">
.privateChat .el-image-viewer__close {
  top: 100px;
  color: red;
}
</style>
